const zIndices = [
  5,       // 0
  10,      // 1
  15,      // 2
  20,      // 3
  25,      // 4
  30,      // 5
  35,      // 6
  40,      // 7
  45,      // 8
  50,      // 9
  55,      // 10
];

export default zIndices
